import { render } from "./ViewImport.vue?vue&type=template&id=41818e87"
const script = {}

import exportComponent from "D:\\victo\\Documents\\Projects\\RawData\\product-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__